import Advice from "components/common/Advice";

const CorporativeCultureContent = () => (
  <Advice
    paragraph={
      <>
        Somos motivados pela vocação cidadã presente no nosso DNA franco-brasileiro. E dessa bela mistura entre Brasil e França, surgiu um jeito único de cuidar das pessoas, com consciência social e acolhimento.
        <br/><br/>
        Quer saber mais sobre a nossa essência? Então vem com a gente!
      </>
    }
  />
);
export default CorporativeCultureContent;
